// Lets the chat widget clear whatever occupies the bottom of the screen, without re-deriving
// each source's route, scroll, and eligibility gating. Keyed by source because the sources
// mount independently: the sticky bar unmounts on navigation while the cart panel it was
// hiding behind stays open, and the panel's own checkout button is still down there.
export type BottomCtaSource =
  | "program-sticky-cta"
  | "cart-panel"
  | "results-sticky-footer";

const occupiedSources = new Set<BottomCtaSource>();
const listeners = new Set<() => void>();

export const setBottomCtaOccupied = (
  source: BottomCtaSource,
  next: boolean
): void => {
  if (occupiedSources.has(source) === next) return;
  if (next) {
    occupiedSources.add(source);
  } else {
    occupiedSources.delete(source);
  }
  // Every source change, not only the aggregate: per-source readers subscribe too.
  listeners.forEach((listener) => listener());
};

export const subscribeBottomCtaOccupied = (
  listener: () => void
): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const getBottomCtaOccupied = (): boolean => occupiedSources.size > 0;

export const isBottomCtaSourceOccupied = (source: BottomCtaSource): boolean =>
  occupiedSources.has(source);
